import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import ToolFontFamily from './ToolFontFamily';
import ToolFontSize from './ToolFontSize';
import ToolTextColor from './ToolTextColor';
import ToolTextHighlight from './ToolTextHighlight';
import ToolBold from '../BoldPlugin/tools/ToolBold';
import ToolItalic from '../ItalicPlugin/tools/ToolItalic';
import ToolStrikethrough from '../StrikethroughPlugin/tools/ToolStrikethrough';
import ToolUnderline from '../UnderlinePlugin/tools/ToolUnderline';
import { unwrapCodeSnippet } from '../CodeSnippetPlugin/utils';
import { Editor, Element, Transforms } from 'slate';

const FORMATTING_TOOLS = [
  ToolBold,
  ToolItalic,
  ToolFontFamily,
  ToolFontSize,
  ToolStrikethrough,
  ToolTextColor,
  ToolTextHighlight,
  ToolUnderline,
];

class ToolClearFormatting extends Tool {
  static toolName = 'Clear styling';
  static iconClass = 'fa-regular fa-eraser';
  static shortcut = 'Cmd+\\';

  static action({ editor, controller }: ToolArgsWithController): void {
    if (!editor?.selection) return;

    // Remove line height from blocks
    Transforms.unsetNodes(editor, 'lineHeight', {
      at: editor.selection,
      match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
    });

    // Editor.marks doesn't always return every mark in a Range so instead
    // we delete all possible marks
    FORMATTING_TOOLS.forEach((tool) => {
      tool.removeMark(editor, controller);
    });

    unwrapCodeSnippet(editor);
  }
}

export default ToolClearFormatting;
